import { defaultsConfig } from "~config/sport/defaults";
import { Disciplines } from "~enums/disciplines";
import type { SportConfiguration } from "~types/sportConfiguration";

export const volleyballConfig: SportConfiguration = {
  ...defaultsConfig,
  disciplines: [Disciplines.Indoor, Disciplines.Beach],
};
